module.exports = __webpack_public_path__ + "SamsungSharpSans-Bold.3fcc0a835e845995df5c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungSharpSans-Bold.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungSharpSans-Bold.ttf
// module chunks = styles